import React from 'react';
// import { connect } from 'react-redux';
import { Title } from '@thecb/components';
import { ContentWrapper } from './ErrorBoundary.styled';
import { Notifier } from '@airbrake/browser';
import { ENVIRONMENTS } from '../../utils/constants';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.handleContinue = this.handleContinue.bind(this);
    this.state = { hasError: false };
    if (
      this.props.config &&
      this.props.config.environment !== ENVIRONMENTS.LOCAL
    ) {
      this.airbrake = new Notifier({
        projectId: props.config.airbrakeProjectId,
        projectKey: props.config.airbrakeProjectKey,
        environment: props.config.environment,
      });
    }
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  /*
   * error: string
   * info: object { componentStack: string }
   */
  componentDidCatch(error, info) {
    // The JS error and relevant information from the app bubble up
    // and are caught here. They do not crash they app, but are logged and sent to reporting
    const errorLogText = `
      Error Boundary Log
      ==================
      Error: ${error.stack}
      ==================
      Info: ${info.componentStack}
    `;
    console.log(errorLogText);

    this.airbrake?.notify({
      error: error,
      params: { info: info },
    });
  }

  handleContinue() {
    /**
     * How should POS handle app level errors?
     * - Static page with error info and force user to refresh
     * - Static page with error info and timeout -> automatic navigate to /index or /logout
     * - Page with button to return to go back/to home? GOING WITH THIS FOR NOW
     */
    this.setState({ hasError: false });
    props.navigate('/');
  }

  render() {
    if (this.state.hasError) {
      return (
        <ContentWrapper>
          <Title as="h2">
            The Cashiering web app has encountered an error.
          </Title>
          <button onClick={this.handleContinue}>Home</button>
          {/* Button with action must be themed - need to wrap in withwindowsize */}
          {/* <ButtonWithAction
            variant="whitePrimary"
            action={this.handleContinue}
            text="Home"
            extraStyles={`padding: 0.75rem 2rem; border: 2px solid blue; &:active { border: 2px solid blue; }`}
          /> */}
        </ContentWrapper>
      );
    }

    return this.props.children;
  }
}

/**
 * TODO:
 * Determine whether this component should be integrated with redux so
 * If so, utilize mapping and connect functions here. Will effect testing.
 */
// const mapStateToProps = (state) => ({});
// const mapDispatchToProps = {};
// export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);

export default ErrorBoundary;
